import React, { useState } from 'react';
import { Card, Button, Input, Alert, PageHeader, Select } from '../../components/ui';
import useAuthStore from '../../store/authStore';
import api from '../../services/api';
import toast from 'react-hot-toast';

const INDIAN_STATES = ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Delhi','Jammu and Kashmir','Ladakh','Puducherry'];

export default function ClientSettings() {
  const { user, fetchMe } = useAuthStore();
  const [tab, setTab] = useState('profile');
  const [profile, setProfile] = useState({
    name: user?.name || '', company: user?.company || '', phone: user?.phone || '',
    timezone: 'Asia/Kolkata',
    address: user?.address || '', city: user?.city || '',
    state: user?.state || '', pincode: user?.pincode || '',
    country: user?.country || 'India', gstNumber: user?.gstNumber || '',
  });
  const [pwd, setPwd] = useState({ current:'', newPwd:'', confirm:'' });
  const [pwdError, setPwdError] = useState('');
  const [pwdSuccess, setPwdSuccess] = useState('');
  const [forgotSent, setForgotSent] = useState(false);
  const [forgotLoading, setForgotLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const saveProfile = async () => {
    setSaving(true);
    try {
      await api.put('/users/profile', profile);
      await fetchMe();
      toast.success('Profile updated!');
    } catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
    finally { setSaving(false); }
  };

  const changePassword = async () => {
    setPwdError(''); setPwdSuccess('');
    if (!pwd.current || !pwd.newPwd || !pwd.confirm) return setPwdError('All fields required');
    if (pwd.newPwd.length < 8) return setPwdError('Min 8 characters');
    if (pwd.newPwd !== pwd.confirm) return setPwdError('Passwords do not match');
    try {
      await api.post('/users/change-password', { currentPassword: pwd.current, newPassword: pwd.newPwd });
      setPwdSuccess('Password changed successfully!');
      setPwd({ current:'', newPwd:'', confirm:'' });
    } catch (err) { setPwdError(err.response?.data?.message || 'Incorrect current password'); }
  };

  const requestReset = async () => {
    setForgotLoading(true);
    try { await api.post('/users/request-password-reset', {}); setForgotSent(true); }
    catch { setForgotSent(true); } finally { setForgotLoading(false); }
  };

  const p = (k, v) => setProfile(prev => ({ ...prev, [k]: v }));

  const TABS = [
    { id:'profile',  label:'👤 Profile' },
    { id:'address',  label:'🏢 Address & GST' },
    { id:'password', label:'🔐 Password' },
  ];

  return (
    <div>
      <PageHeader title="Settings" subtitle="Manage your account" />

      <div style={{ display:'flex', gap:4, marginBottom:24, borderBottom:'1px solid rgba(46,204,113,0.1)' }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{ padding:'10px 20px', background:'none', border:'none', borderBottom:`2px solid ${tab===t.id?'#2ECC71':'transparent'}`, color:tab===t.id?'#2ECC71':'#666', fontWeight:tab===t.id?700:400, fontSize:14, cursor:'pointer', marginBottom:-1 }}>
            {t.label}
          </button>
        ))}
      </div>

      {/* ── PROFILE ── */}
      {tab === 'profile' && (
        <Card style={{ maxWidth:560 }}>
          <h3 style={{ fontWeight:700, marginBottom:20 }}>Profile Information</h3>
          <Input label="Full Name" value={profile.name} onChange={e => p('name', e.target.value)} />
          <div style={{ marginBottom:16 }}>
            <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#888', marginBottom:6 }}>Email Address</label>
            <div style={{ padding:'10px 14px', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.06)', borderRadius:10, color:'#666', fontSize:14 }}>{user?.email} <span style={{ fontSize:11, color:'#444' }}>(cannot be changed)</span></div>
          </div>
          <Input label="Company Name" value={profile.company} onChange={e => p('company', e.target.value)} />
          <Input label="Phone" value={profile.phone} onChange={e => p('phone', e.target.value)} />
          <div style={{ marginBottom:16 }}>
            <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#ccc', marginBottom:6 }}>Timezone</label>
            <div style={{ padding:'10px 14px', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.06)', borderRadius:10, color:'#666', fontSize:14 }}>Asia/Kolkata <span style={{ fontSize:11, color:'#444' }}>(fixed)</span></div>
          </div>
          <Button loading={saving} onClick={saveProfile}>Save Changes</Button>
        </Card>
      )}

      {/* ── ADDRESS & GST ── */}
      {tab === 'address' && (
        <div style={{ maxWidth:560 }}>
          <Card style={{ marginBottom:16 }}>
            <h3 style={{ fontWeight:700, marginBottom:6 }}>Business Address</h3>
            <p style={{ fontSize:13, color:'#666', marginBottom:20, lineHeight:1.6 }}>This address will appear on your invoices. Enter your complete business address.</p>
            <Input label="Street Address" placeholder="Building, Street, Area" value={profile.address} onChange={e => p('address', e.target.value)} />
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
              <Input label="City" placeholder="City" value={profile.city} onChange={e => p('city', e.target.value)} />
              <Input label="Pincode" placeholder="638182" value={profile.pincode} onChange={e => p('pincode', e.target.value)} />
            </div>
            <div style={{ marginBottom:16 }}>
              <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#ccc', marginBottom:6 }}>Country</label>
              <select value={profile.country} onChange={e => { p('country', e.target.value); if (e.target.value !== 'India') p('state', ''); }} style={{ width:'100%', padding:'10px 14px', background:'#1a1a1a', border:'1px solid rgba(46,204,113,0.15)', borderRadius:10, color:'#fff', fontSize:14, outline:'none' }}>
                {['India','United States','United Kingdom','Germany','France','Singapore','Australia','Canada','UAE','Other'].map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            {profile.country === 'India' && (
              <div style={{ marginBottom:16 }}>
                <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#ccc', marginBottom:6 }}>State</label>
                <select value={profile.state} onChange={e => p('state', e.target.value)} style={{ width:'100%', padding:'10px 14px', background:'#1a1a1a', border:'1px solid rgba(46,204,113,0.15)', borderRadius:10, color:'#fff', fontSize:14, outline:'none' }}>
                  <option value="">Select state...</option>
                  {INDIAN_STATES.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            )}
          </Card>

          <Card style={{ marginBottom:16 }}>
            <h3 style={{ fontWeight:700, marginBottom:6 }}>GST Information</h3>
            <p style={{ fontSize:13, color:'#666', marginBottom:16, lineHeight:1.6 }}>Enter your GST number if you are a GST registered business. This will be shown on invoices and GST will be applied accordingly.</p>
            <Input label="GST Number (optional)" placeholder="e.g. 33XXXXX0000X1ZX" value={profile.gstNumber} onChange={e => p('gstNumber', e.target.value.toUpperCase())} hint="Leave blank if not registered. Only applicable for India." />
            {profile.gstNumber && profile.country === 'India' && (
              <div style={{ background:'rgba(46,204,113,0.06)', border:'1px solid rgba(46,204,113,0.15)', borderRadius:10, padding:'12px 16px', fontSize:13 }}>
                <div style={{ fontWeight:700, color:'#2ECC71', marginBottom:4 }}>GST Preview on Invoice</div>
                <div style={{ color:'#888' }}>
                  {profile.state === 'Tamil Nadu'
                    ? '📍 Tamil Nadu client → SGST 9% + CGST 9% (Total 18%)'
                    : profile.state
                      ? `📍 ${profile.state} client → IGST 18%`
                      : 'Select your state to see GST type'}
                </div>
              </div>
            )}
            {profile.country !== 'India' && (
              <Alert type="info">International client — No GST will be applied on invoices.</Alert>
            )}
          </Card>

          <Button loading={saving} onClick={saveProfile}>Save Address & GST</Button>
        </div>
      )}

      {/* ── PASSWORD ── */}
      {tab === 'password' && (
        <div style={{ maxWidth:560 }}>
          <Card style={{ marginBottom:16 }}>
            <h3 style={{ fontWeight:700, marginBottom:20 }}>Change Password</h3>
            {pwdError && <Alert type="danger" style={{ marginBottom:16 }}>{pwdError}</Alert>}
            {pwdSuccess && <Alert type="success" style={{ marginBottom:16 }}>{pwdSuccess}</Alert>}
            <Input label="Current Password" type="password" value={pwd.current} onChange={e => setPwd(p=>({...p,current:e.target.value}))} />
            <Input label="New Password" type="password" placeholder="Min. 8 characters" value={pwd.newPwd} onChange={e => setPwd(p=>({...p,newPwd:e.target.value}))} />
            <Input label="Confirm New Password" type="password" value={pwd.confirm} onChange={e => setPwd(p=>({...p,confirm:e.target.value}))} />
            <Button onClick={changePassword}>🔐 Update Password</Button>
          </Card>
          <Card style={{ background:'rgba(243,156,18,0.04)', border:'1px solid rgba(243,156,18,0.18)' }}>
            <h3 style={{ fontWeight:700, marginBottom:10 }}>🔑 Forgot Current Password?</h3>
            <p style={{ fontSize:13, color:'#888', lineHeight:1.7, marginBottom:16 }}>Request a password reset. Admin will email a new password to <strong style={{ color:'#ccc' }}>{user?.email}</strong>.</p>
            {forgotSent
              ? <Alert type="success">✅ Reset request sent! Admin will email you within working hours.</Alert>
              : <Button variant="outline" loading={forgotLoading} onClick={requestReset}>📧 Request Password Reset</Button>}
          </Card>
        </div>
      )}
    </div>
  );
}
